/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_account_forgot_password_errors_429 = /** @type {(inputs: {}) => string} */ () => {
	return `Příliš mnoho požadavků. Prosím zkuste později.`
};

const da_account_forgot_password_errors_429 = /** @type {(inputs: {}) => string} */ () => {
	return `For mange forsøg. Prøv igen senere.`
};

const de_account_forgot_password_errors_429 = /** @type {(inputs: {}) => string} */ () => {
	return `Zu viele Anfragen. Bitte versuchen Sie es später erneut.`
};

const en_account_forgot_password_errors_429 = /** @type {(inputs: {}) => string} */ () => {
	return `Too many requests. Please try again later.`
};

const es_account_forgot_password_errors_429 = /** @type {(inputs: {}) => string} */ () => {
	return `Demasiadas solicitudes. Por favor, inténtalo más tarde.`
};

const fr_account_forgot_password_errors_429 = /** @type {(inputs: {}) => string} */ () => {
	return `Trop de demandes. Veuillez réessayer plus tard.`
};

const hu_account_forgot_password_errors_429 = /** @type {(inputs: {}) => string} */ () => {
	return `Túl sok kérés. Kérjük, próbálkozz később.`
};

const it_account_forgot_password_errors_429 = /** @type {(inputs: {}) => string} */ () => {
	return `Troppe richieste. Riprova più tardi.`
};

const nl_account_forgot_password_errors_429 = /** @type {(inputs: {}) => string} */ () => {
	return `Te veel verzoeken. Probeer het later opnieuw.`
};

const pl_account_forgot_password_errors_429 = /** @type {(inputs: {}) => string} */ () => {
	return `Za dużo prób. Spróbuj ponownie później.`
};

const pt_account_forgot_password_errors_429 = /** @type {(inputs: {}) => string} */ () => {
	return `Muitas solicitações. Por favor, tente novamente mais tarde.`
};

const sv_account_forgot_password_errors_429 = /** @type {(inputs: {}) => string} */ () => {
	return `För många försök. Försök igen senare.`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const account_forgot_password_errors_429 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.account_forgot_password_errors_429(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("account_forgot_password_errors_429", locale)
	if (locale === "cs") return cs_account_forgot_password_errors_429(inputs)
	if (locale === "da") return da_account_forgot_password_errors_429(inputs)
	if (locale === "de") return de_account_forgot_password_errors_429(inputs)
	if (locale === "en") return en_account_forgot_password_errors_429(inputs)
	if (locale === "es") return es_account_forgot_password_errors_429(inputs)
	if (locale === "fr") return fr_account_forgot_password_errors_429(inputs)
	if (locale === "hu") return hu_account_forgot_password_errors_429(inputs)
	if (locale === "it") return it_account_forgot_password_errors_429(inputs)
	if (locale === "nl") return nl_account_forgot_password_errors_429(inputs)
	if (locale === "pl") return pl_account_forgot_password_errors_429(inputs)
	if (locale === "pt") return pt_account_forgot_password_errors_429(inputs)
	return sv_account_forgot_password_errors_429(inputs)
};
export { account_forgot_password_errors_429 as "account.forgot_password_errors.429" }